// @ts-ignore
import pako from 'pako'
import { SocketTypeMap } from '../index'
import WsResultPb_pb from './protoData/WsResultPb_pb'
import { messageDataHandler } from './createTradeMessageDataHandler'
import { TTimezone } from '../../types'
type TProcessData<T extends keyof SocketTypeMap> = (data: SocketTypeMap[T]) => any

export type TUseSocketConfig<T extends keyof SocketTypeMap> = {
  topicKey: T
  enableTimezone?: boolean
  params: any
}

export type TGetSocketMessageKey = (message: MessageEvent) => Promise<{ key: string; data: any } | void>

export const createGenerateMessageId = (timezone: TTimezone) => (config: TUseSocketConfig) => {
  if (config.enableTimezone) {
    const key = config.topicKey + (timezone ? '.' + timezone : '')
    return key
  }
  return config.topicKey
}

export const createGetSocketMessageIdAndData = (timezone: TTimezone) => {
  const getSocketMessageIdAndData: TGetSocketMessageKey = (message: MessageEvent, params) => {
    return new Promise((resolve, reject) => {
      if (typeof message.data === 'string') {
        const json = JSON.parse(message.data)
        if (json.ch && json.code && json.code != 200) {
          // queue.forEach(item => {
          //   if (item.sub.toUpperCase() == json.ch.toUpperCase()) {
          //     send(item)
          //   }
          // })
        }
        return
      }

      //获取数据步骤，
      // 1：将文件流转换为二进制文件，
      // 2: 解压二进制文件,后端采用gzip压缩，
      // 3：将解压数据使用protoBuffer反序列化为实体对象
      // 4：将实体对象转换为json
      let result,
        data,
        reader = new FileReader()
      reader.readAsBinaryString(message.data)
      reader.onload = () => {
        result = pako.inflate(reader.result)
        // @ts-ignore
        data = WsResultPb_pb.WsResultPb.deserializeBinary(result)
        data = data.toObject()
        const key = data.ch
        data = messageDataHandler(data, {
          timezone,
        })
        resolve({ key, data: data })
      }
    })
  }
  return getSocketMessageIdAndData
}

export const sendMessageHandler = (type: 'subscribe' | 'unsubscribe', config: any, socket: WebSocket) => {
  // todo: 根据入参params判断是否需要登录
  socket.send(
    JSON.stringify({
      signin: { token: window.localStorage.getItem('token') },
    })
  )

  let timezone = ''
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search)
    timezone = (searchParams.get('timezone') as TTimezone) || (localStorage.getItem('rangeBenchmark') as TTimezone)
  }
  const key = createGenerateMessageId(timezone)(config)
  // const key = config.topicKey + (timezone ? '.' + timezone : '')
  if (type === 'unsubscribe') {
    return JSON.stringify({
      unsub: key,
    })
  }

  return JSON.stringify({
    ...config.params,
    sub: key,
  })
}
export default createGetSocketMessageIdAndData
